"use client";

import { useMessages } from "next-intl";
import { useMemo } from "react";

import { registerMessagePaths } from "@/utils/nextIntl";

/**
 * Registers the full set of translation-message paths (from the already-hydrated
 * client messages) so `getMessageFallback` in `@/utils/nextIntl` can tell an
 * intentional country/variant probe (which has a `.default` fallback) apart from
 * a genuinely missing key. Renders nothing.
 *
 * Mounted as the FIRST child inside `NextIntlClientProvider` (see app/layout.tsx)
 * so the path set is normally populated before any sibling's `t()` call. The
 * safety net, though, is `getMessageFallback`'s conservative behaviour when the
 * set isn't ready yet (report) plus its per-key dedup — not strict render
 * ordering. Reads the messages next-intl already shipped to the client, so it
 * adds no bundle weight.
 */
export function IntlPathRegistrar() {
  const messages = useMessages();
  // useMemo (not useEffect) so registration happens during render, before the
  // sibling subtree renders and its t() lookups can fire. registerMessagePaths
  // is idempotent.
  useMemo(() => registerMessagePaths(messages), [messages]);
  return null;
}
